import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import PastClass from '../../../../pages/common/Statistic/PastClasses/PastClass'
import UsePagination from '../../../pagination'
import DropDown from '../../../Input/DropDown'

import { getTutorPastClasses } from '../../../../routing/fetchingfunction/dashboard/dashboard.action'
import {
  selectLoadingTutorPastClasses,
  selectTutorPastClassesPagination,
} from '../../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { getPaginationTotalLength } from '../../../../helpers'

const TutorPastClasses = () => {
  const dispatch = useDispatch()

  const {
    tutorPastClasses,
    tutorPastClassesPage,
    tutorPastClassesPageSize,
    tutorPastClassesTotal,
  } = useSelector(selectTutorPastClassesPagination)
  const isLoading = useSelector(selectLoadingTutorPastClasses)

  const handlePageChange = (_, value) => {
    if (value !== tutorPastClassesPage) {
      dispatch(
        getTutorPastClasses({
          page: value,
        })
      )
    }
  }

  useEffect(() => {
    dispatch(getTutorPastClasses())
  }, [dispatch])

  const pastClassesContent = tutorPastClasses.map((tutorPastClass) => {
    return <PastClass key={tutorPastClass.id} pastClass={tutorPastClass} />
  })

  return (
    <div className="mt-[64px] mb-[20px]">
      <div className="flex items-center justify-between mb-[20px]">
        <h3 className="text-2xl font-bold text-white">Past Classes</h3>

        {/*<div className="flex items-center gap-x-[20px]">*/}
        {/*  <DropDown*/}
        {/*    menuItems={[*/}
        {/*      {*/}
        {/*        value: 'date',*/}
        {/*        label: 'Date',*/}
        {/*      },*/}
        {/*    ]}*/}
        {/*    value="date"*/}
        {/*    placeholder="Date"*/}
        {/*    className="!h-[44px]"*/}
        {/*  />*/}
        {/*</div>*/}
      </div>

      {pastClassesContent}

      {tutorPastClassesTotal > tutorPastClassesPageSize && (
        <div className="w-full flex items-center justify-center">
          <UsePagination
            count={getPaginationTotalLength(tutorPastClassesTotal, tutorPastClassesPageSize)}
            page={tutorPastClassesPage}
            onChange={handlePageChange}
            loading={isLoading}
          />
        </div>
      )}
    </div>
  )
}

export default TutorPastClasses
